import styled, { css } from "styled-components";
import {Text} from "@fluentui/react-components";
import { DismissRegular, MoreHorizontalRegular } from "@fluentui/react-icons";
import { ReactComponent as Logo } from 'src/assets/attachedFileLogo.svg'

export const FileAttachmentFrame = styled.div`
    padding: 8px 12px 8px 12px;
    margin: 8px;
    display: flex;
    justify-content: space-between;
    border: 1px solid ${(props) => props.theme.serviceDeskFileAttachmentBorder};
    background-color: ${(props) => props.theme.serviceDeskFileAttachmentBackground};
    border-radius: 4px;
    width: fit-content;
    align-items: center;
    box-shadow: 0px 0px 2px 0px #0000001F;
    box-shadow: 0px 1px 2px 0px #00000024;

    @media(max-width: 710px) {
        width: auto;
    }
`;

export const AttachedFileLogo = styled(Logo)`
  width: 32px;
  height: 32px;
`;

export const FileInfoWrapper = styled.div`
    display: flex;
    flex-direction: column;
`;

export const FileName = styled(Text)`
    font-size: 14px;
    line-height: 20px;
    font-weight: 600;
`;

export const FileDescription = styled(Text)`
    font-size: 12px;
    line-height: 16px;
    font-weight: 400;
    max-width: 320px;
`;

export const Icon = css`
    width: 20px;
    height: 20px;
`;
export const DismissIcon = styled(DismissRegular)`
    ${Icon};
    top: 50%;
`;

export const MoreHorizontalIcon = styled(MoreHorizontalRegular)`
    ${Icon};
`;

export const FileIconAndNameWrapper = styled.div`
    display: flex;
    flex-direction: row;
    position: relative;
`;
